import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as driversActions from './../actions/drivers.actions';
import { map, catchError, switchMap, share } from 'rxjs/operators';
import { of } from 'rxjs';
import * as notifyActions from '../../general/actions/notify.actions';
import { MwDriversApiService } from 'app/services/drivers-api.service';

@Injectable()
export class DriversEffects {
  loadDrivers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(driversActions.loadDrivers),
      switchMap(({ loadOptions }) =>
        this.driversApiService.getDrivers(loadOptions).pipe(
          map((response) => driversActions.loadDriversSuccess({ response })),
          catchError((error) => of(driversActions.loadDriversFailed({ error })))
        )
      )
    )
  );

  createDriver$ = createEffect(() =>
    this.actions$.pipe(
      ofType(driversActions.createDriver),
      switchMap(({ driver }) =>
        this.driversApiService.createDriver(driver).pipe(
          switchMap(() => [
            driversActions.createDriverSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.add_driver_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(driversActions.createDriverFailed({ error }))
          )
        )
      )
    )
  );

  updateDriver$ = createEffect(() =>
    this.actions$.pipe(
      ofType(driversActions.updateDriver),
      switchMap(({ driver }) =>
        this.driversApiService.updateDriver(driver).pipe(
          switchMap((response) => [
            driversActions.updateDriverSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.edit_driver_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(driversActions.updateDriverFailed({ error }))
          )
        )
      )
    )
  );

  deleteDriver$ = createEffect(() =>
    this.actions$.pipe(
      ofType(driversActions.deleteDriver),
      switchMap(({ driver }) =>
        this.driversApiService.deleteDriver(driver).pipe(
          switchMap(() => [
            driversActions.deleteDriverSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_driver_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(driversActions.deleteDriverFailed({ error }))
          )
        )
      )
    )
  );

  deleteDriversList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(driversActions.deleteDriversList),
      switchMap(({ drivers }) =>
        this.driversApiService.deleteDriversList(drivers).pipe(
          switchMap(() => [
            driversActions.deleteDriversListSuccess(),
            notifyActions.notifySuccess({
              notification: {
                phrase: 'OPERATION.delete_drivers_successful',
              },
            }),
          ]),
          catchError((error) =>
            of(driversActions.deleteDriversListFailed({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private driversApiService: MwDriversApiService
  ) {}
}
